'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = function () {
	return function (JSONData, ReportTitle, ShowLabel) {
		var arrData = (typeof JSONData === 'undefined' ? 'undefined' : _typeof(JSONData)) != 'object' ? JSON.parse(JSONData) : JSONData;

		var CSV = '';

		if (ShowLabel) {
			var row = "";

			for (var index in arrData[0]) {
				row += index + ',';
			}

			row = row.slice(0, -1);

			CSV += row + '\r\n';
		}

		for (var i = 0; i < arrData.length; i++) {
			var row = "";

			for (var index in arrData[i]) {
				row += '"' + arrData[i][index] + '",';
			}

			row.slice(0, row.length - 1);

			CSV += row + '\r\n';
		}

		if (CSV == '') {
			alert("Invalid data");
			return;
		}

		var fileName = ReportTitle.replace(/ /g, "_");

		var uri = 'data:text/csv;charset=utf-8,' + escape(CSV);

		var link = document.createElement("a");
		link.href = uri;

		link.style = "visibility:hidden";
		link.download = fileName + ".csv";

		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	};
};


// WEBPACK FOOTER //
// ./client/components/misc-services/json-to-csv.js